<template>
  <b-row class="mt-4">
    <b-col></b-col>
    <b-col lg="3" class="text-right">
      <div class="valoracion-precio">
        <!-- CUOTA -->

        <!-- Cuota mensual -->
        <div class="bloque-valoracion" v-if="cuotaEsMensual">
          <h5>Cuota mensual</h5>
          <div class="text-right">
            {{ importeCuotaMensualCalculada }}
            <span class="divisa-coloreada">
              {{ divisa.simbolo || divisa.abreviatura }}
            </span>
          </div>
        </div>

        <!-- Cuota anual -->
        <div class="bloque-valoracion" v-if="!cuotaEsMensual">
          <h5>Cuota anual</h5>
          <div class="text-right">
            {{ importeCuotaAnual }}
            <span class="divisa-coloreada">
              {{ divisa.simbolo || divisa.abreviatura }}
            </span>
          </div>
        </div>

        <!-- descuento firma -->
        <div class="bloque-valoracion descuento" v-show="oferta.importeDescuentoPorFirmaEnPlazo > 0">
          <h5 title="Es el descuento por firma anticipada">
            Compromiso de firma ({{ oferta.tipoDescuentoPorFirmaEnPlazo }}%)
          </h5>
          <div class="text-right">
            {{ importeDescuentoPorFirmaEnPlazo }}
            <span class="divisa-coloreada">
              {{ divisa.simbolo || divisa.abreviatura }}
            </span>
          </div>
        </div>

        <!-- descuento cuota forma pago -->
        <div class="bloque-valoracion descuento" v-show="oferta.importeDescuentoPorFormaPago > 0">
          <h5 title="Es el descuento por forma de pago">Forma de pago ({{ oferta.tipoDescuentoPorFormaPago }}%)</h5>
          <div class="text-right">
            {{ importeDescuentoPorFormaPago }}
            <span class="divisa-coloreada">
              {{ divisa.simbolo || divisa.abreviatura }}
            </span>
          </div>
        </div>

        <div class="bloque-valoracion descuento" v-show="oferta.importeDescuentoCuotaAnual > 0">
          <h5>Descuento ({{ oferta.tipoDescuentoCuotaAnual }}%)</h5>
          <div class="text-right">
            {{ importeDescuentoCuotaAnual }}
            <span class="divisa-coloreada">
              {{ divisa.simbolo || divisa.abreviatura }}
            </span>
          </div>
        </div>

        <!-- Total si hay descuentos -->
        <div class="bloque-valoracion" v-show="cuotaTieneDescuento">
          <h5>Cuota anual con descuentos</h5>
          <div class="text-right">
            {{ importeCuotaFinalConDescuentos }}
            <span class="divisa-coloreada"> {{ divisa.simbolo || divisa.abreviatura }} </span>
          </div>
        </div>

        <!-- Suscripcion -->
        <div class="bloque-valoracion" v-show="oferta.importeSuscripcion > 0">
          <h5>Suscripción</h5>
          <div class="text-right">
            {{ importeSuscripcion }}
            <span class="divisa-coloreada">
              {{ divisa.simbolo || divisa.abreviatura }}
            </span>
          </div>
        </div>

        <!-- Implementacion -->
        <div class="bloque-valoracion" v-show="oferta.importeImplementacion > 0">
          <h5>Implementación</h5>
          <div class="text-right">
            {{ importeImplementacion }}
            <span class="divisa-coloreada">
              {{ divisa.simbolo || divisa.abreviatura }}
            </span>
          </div>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from "pinia";
import { useOfertaFormStore } from "@/stores/OfertaFormStore.js";
import { MENSUAL } from "@/enums/TipoCuota.js";

export default {
  computed: {
    ...mapState(useOfertaFormStore, ["oferta", "divisa"]),
    cuotaEsMensual() {
      return this.oferta.tipoCuota === MENSUAL;
    },
    mostrarImporteSuscripcion() {
      return this.oferta.importeSuscripcion > 0;
    },
    importeSuscripcion() {
      return this.prepararImporte(this.oferta.importeSuscripcion);
    },
    importeImplementacion() {
      return this.prepararImporte(this.oferta.importeImplementacion);
    },
    importeCuotaAnual() {
      return this.prepararImporte(this.oferta.importeCuotaAnual);
    },
    importeDescuentoCuotaAnual() {
      return this.prepararImporte(this.oferta.importeDescuentoCuotaAnual * -1);
    },
    importeDescuentoPorFirmaEnPlazo() {
      return this.prepararImporte(this.oferta.importeDescuentoPorFirmaEnPlazo * -1);
    },
    importeDescuentoPorFormaPago() {
      return this.prepararImporte(this.oferta.importeDescuentoPorFormaPago * -1);
    },
    importeTotalInicial() {
      return this.prepararImporte(this.oferta.importeTotalInicial);
    },
    importeTotalEstimado() {
      return this.prepararImporte(this.oferta.importeTotalEstimado);
    },
    importeRecurrenteAnual() {
      return this.prepararImporte(this.oferta.importeRecurrenteAnual);
    },
    importeCuotaFinalConDescuentos() {
      return this.prepararImporte(Math.round(this.oferta.totalCuotaAnual));
    },
    importeCuotaMensual() {
      return this.prepararImporte(Math.round(this.oferta.totalCuotaMensual));
    },
    cuotaTieneDescuento() {
      return Boolean(this.oferta.tieneDescuentosVisibles);
    },
    importeCuotaMensualCalculada() {
      return this.prepararImporte(this.oferta.importeTotalInicial / 12);
    },
    cuotaMensualEstimada() {
      return this.prepararImporte(this.oferta.cuotaMensualEstimada);
    },
  },
  methods: {
    prepararImporte(value) {
      const options = { maximumFractionDigits: 0, useGrouping: true };
      return Intl.NumberFormat("es-ES", options).format(Math.round(value));
    },
  },
};
</script>
